import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-retailer-certificate',
  templateUrl: './retailer-certificate.component.html',
  styleUrls: ['./retailer-certificate.component.scss']
})
export class RetailerCertificateComponent implements OnInit {
  pdfurl: any;
  pdfName: string;

  constructor(private auth: AuthService,private ngxService: NgxUiLoaderService,private toastr: ToastrService, ) { }

  ngOnInit(): void {
  }

  downloadCertificate() {
  this.generateCertificate();
  }
  generateCertificate(){
    this.ngxService.start();
    this.auth.generateCertificateApi().subscribe((res:any)=>{
      this.ngxService.stop();

      if(res.status_code == 1){
        
        this.pdfurl=res.receiptURl
        window.open(this.pdfurl);
        this.toastr.success(res.message);
      

      }else {

        this.toastr.error(res.error.message);

      }
    },err=>{
      this.ngxService.stop();

    })
  }
}
